<template>
  <div class="row">
    <div class="col-6">
      <a-checkbox
        v-model="license.b"
        :label="$t('licenseTypes.car')"
        @change="updateValue"
        :error="error"
      ></a-checkbox>
    </div>
    <div class="col-6">
      <a-checkbox
        v-model="license.c"
        :label="$t('licenseTypes.motto')"
        @change="updateValue"
        :error="error"
      ></a-checkbox>
    </div>
    <div
      class="form-text-validation form-text-validation--error col-12"
      v-if="error"
    >
      <span class="text-validation">
        {{ errorMessage }}
      </span>
    </div>
  </div>
</template>

<script>
import ACheckbox from '@/components/ui/ACheckbox';

export default {
  props: {
    value: {},
    errorMessage: {
      type: String,
      default: null,
    },
    error: {
      default: false,
      type: Boolean,
    },
  },
  components: {
    ACheckbox,
  },
  data() {
    return {
      license: {
        b: false,
        c: false,
      },
    };
  },
  computed: {
    driveLicenseType() {
      return this.license.b && this.license.c
        ? '2'
        : this.license.b
        ? '0'
        : this.license.c
        ? '1'
        : null;
    },
  },
  methods: {
    updateValue() {
      this.$emit('input', this.driveLicenseType);
    },
  },
};
</script>

<style></style>
